import Vue from 'vue'
import ToastComponent from './index.vue'

const Toast = {}
let instance = null

const createInstance = () => {
  if (!instance) {
    const ToastConstructor = Vue.extend(ToastComponent)
    instance = new ToastConstructor().$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)
  }
  return instance
}

Toast.install = function (Vue) {
  Vue.prototype.$toast = (message, duration = 3000, show_error = false) => {
    createInstance().showToast(message, duration, show_error)
  }
}

Toast.show = (message, duration = 3000, show_error = false) => {
  createInstance().showToast(message, duration, show_error)
}

export default Toast
